import { Action } from "@ngrx/store";
import { InfoProfesionalError, InfoProfesionalEstadoEnum, RedSocialDisponible, UsuarioContacto, UsuarioInfoProfesional, UsuarioPerfil } from "../../common/informacion-personal";
import { InformacionPersonalActionTypes } from "./informacion-personal.actions";

export interface InformacionPersonalState {
	perfilReady: boolean,
	perfil: UsuarioPerfil,
	contactoReady: boolean,
	contacto: UsuarioContacto,
	infoProfesionalReady: boolean,
	infoProfesional: UsuarioInfoProfesional,
	redesDisponibles: RedSocialDisponible[],
	redesDisponiblesReady: boolean,
	infoProfEstado: InfoProfesionalEstadoEnum,
	infoProfErrors: InfoProfesionalError
}

export const initialInformacionPersonalState: InformacionPersonalState = {
	perfilReady: true,
	perfil: null,
	contactoReady: true,
	contacto: null,
	infoProfesionalReady: true,
	infoProfesional: null,
	redesDisponiblesReady: true,
	redesDisponibles: [],
	infoProfEstado: InfoProfesionalEstadoEnum.VIEWING,
	infoProfErrors: null
}

export function informacionPersonalReducer( state = initialInformacionPersonalState, action: Action ): InformacionPersonalState {
	switch( action.type ) {
		case InformacionPersonalActionTypes.UsuarioInfoCleared:
			return {
				...state,
				perfil: null,
				contacto: null,
				infoProfesional: null
			};
		case InformacionPersonalActionTypes.UsuarioPerfilRequested:
			return { ...state, perfilReady: false };
		case InformacionPersonalActionTypes.UsuarioPerfilLoaded:
			return { ...state, perfil: action["payload"]["perfil"], perfilReady: true };
		case InformacionPersonalActionTypes.UsuarioPerfilAlreadyLoaded:
		case InformacionPersonalActionTypes.UsuarioPerfilCancelled:
			return { ...state, perfilReady: true };

		case InformacionPersonalActionTypes.UsuarioContactoRequested:
			return { ...state, contactoReady: false };
		case InformacionPersonalActionTypes.UsuarioContactoLoaded:
			return { ...state, contacto: action["payload"]["contacto"], contactoReady: true };
		case InformacionPersonalActionTypes.UsuarioContactoCancelled:
			return { ...state, contactoReady: true };

		case InformacionPersonalActionTypes.RedesDisponiblesRequested:
			return { ...state, redesDisponiblesReady: false };
		case InformacionPersonalActionTypes.RedesDisponiblesLoaded:
			return { ...state, redesDisponibles: action["payload"]["redesDisponibles"], redesDisponiblesReady: true };
		case InformacionPersonalActionTypes.RedesDisponiblesCancelled:
			return { ...state, redesDisponiblesReady: true, infoProfEstado: InfoProfesionalEstadoEnum.ERROR };
		case InformacionPersonalActionTypes.RedesDisponiblesAlreadyLoaded:
			return { ...state, redesDisponiblesReady: true };

		case InformacionPersonalActionTypes.UsuarioInfoProfesionalRequested:
			return { ...state, infoProfesionalReady: false };
		case InformacionPersonalActionTypes.UsuarioInfoProfesionalLoaded:
			return { ...state, infoProfesional: action["payload"]["infoProfesional"], infoProfesionalReady: true };
		case InformacionPersonalActionTypes.UsuarioInfoProfesionalCancelled:
			return { ...state, infoProfesionalReady: true, infoProfEstado: InfoProfesionalEstadoEnum.ERROR };

		case InformacionPersonalActionTypes.StartEditingInfoProfesional:
			return { ...state, infoProfEstado: InfoProfesionalEstadoEnum.EDITING };
		case InformacionPersonalActionTypes.CancelEditingInfoProfesional:
			return {
				...state,
				infoProfEstado: InfoProfesionalEstadoEnum.VIEWING,
				infoProfErrors: null
			};
		case InformacionPersonalActionTypes.SaveEditingInfoProfesionalRequested:
			return {
				...state,
				infoProfEstado: InfoProfesionalEstadoEnum.SAVING,
				infoProfErrors: null
			};
		case InformacionPersonalActionTypes.SaveEditingInfoProfesionalSuccess:
			return {
				...state,
				infoProfEstado: InfoProfesionalEstadoEnum.VIEWING,
				infoProfErrors: null,
				infoProfesionalReady: false
			};
		case InformacionPersonalActionTypes.SaveEditingInfoProfesionalError:
			return {
				...state,
				infoProfEstado: InfoProfesionalEstadoEnum.VIEWING,
				infoProfErrors: null
			};
		case InformacionPersonalActionTypes.SaveEditingInfoProfesionalInvalid:
			return {
				...state,
				infoProfEstado: InfoProfesionalEstadoEnum.EDITING,
				infoProfErrors: {
					...state.infoProfErrors,
					resenaError: action["payload"]["errors"]["resenaError"],
					redesError: action["payload"]["errors"]["redesError"],
					redesInvalidas: action["payload"]["errors"]["redesInvalidas"]
				}
			};

		// Buscador related cases
		case InformacionPersonalActionTypes.SetEstadoInfoProfesional:
			return {  ...state, infoProfEstado: action["payload"]["estado"] };

		default:
			return state;
	}
}